import {
	INITIAL_BUSINESS_CENTER_REQUEST,
	FETCH_BUSINESS_CENTER_SUCCESS,
	FINAL_BUSINESS_CENTER_REQUEST,
	BUSINESS_CENTER_SHOW,
} from "../../types/maintainers/business_center.type";

const initialState = {
	estates: [],
	customers: [],
	categories: [],
	species: [],
	varieties: [],
	quarters: [],
	crops: [],
	business_center: [],
	last_page: 0,
	from: 0,
	to: 0,
	isFetching: false,
};

function maintainers_business_center(state = initialState, action) {
	switch (action.type) {
		case INITIAL_BUSINESS_CENTER_REQUEST:
			return {
				...state,
				isFetching: true,
			};
		case FETCH_BUSINESS_CENTER_SUCCESS:
			return {
				...state,
				isFetching: false,
				customers: action.payload.customers,
				estates: action.payload.estates,
				categories: action.payload.categories,
				species: action.payload.species,
				varieties: action.payload.varieties,
				quarters: action.payload.quarters,
				crops: action.payload.crops,
				business_center: action.payload.business_center,
				last_page: action.payload.last_page,
				from: action.payload.from,
				to: action.payload.to,
				quantity: action.payload.quantity,
			};
		case FINAL_BUSINESS_CENTER_REQUEST:
			return {
				...state,
				isFetching: false,
			};
		case BUSINESS_CENTER_SHOW:
			return {
				...state,
				business_center: action.payload.business_center,
			};
		default:
			return state;
	}
}

export default maintainers_business_center;
